document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll("tr.membership input.reportable")
    .forEach(function (el) {
      el.addEventListener("click", function (e) {
        const tr = e.target.closest("tr");
        const payload = {
          membership: {
            reportable: e.target.checked,
          },
        };
        fetch("/memberships/" + tr.getAttribute("data-id"), {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
              .content,
          },
          method: "PUT",
          dataType: "JSON",
          body: JSON.stringify(payload),
          // # success: (response) ->
          //   #   $tr.addClass("highlight");
          //   #   $tr.on("animationend", () => $tr.removeClass("highlight"));

          // # error: (response) ->
          //   #   $tr.effect('highlight', {color: '#ff0000'}, 2000)
        });
      });
    });
});
